module.exports = __webpack_public_path__ + "img/nfc_off.8208059e.svg";